
import { Cmd_OfPromise_either } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../CommunicationV2.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { singleton, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { LabelConfiguration_$reflection, CustomerConfiguration_$reflection } from "../Shared/Shared.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { ReservedQrCodeDto_$reflection, LabelPreviewData_$reflection, LabelPrintRequest_$reflection, LabelPrintResponse_$reflection, LabelPrintItem_$reflection, LabelPrintCandidate_$reflection } from "../Shared/Label.js";
import { unit_type, list_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { addPrefix as addPrefix_1, fetchWithDecoder as fetchWithDecoder_1 } from "../Communication.js";
import { concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";

export function updateLabelConfiguration(data, successMsg, errorMsg) {
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), CustomerConfiguration_$reflection()));
        }, refreshOn)))(true);
    })), ["/api/customer/labels", toString(0, Auto_generateBoxedEncoder_437914C6(LabelConfiguration_$reflection(), undefined, undefined, undefined)(data))], successMsg, errorMsg);
}

export function getLabelCandidates(items, successMsg, errorMsg) {
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(LabelPrintCandidate_$reflection())));
        }, refreshOn)))(true);
    })), ["/api/labels/candidates", toString(0, Auto_generateBoxedEncoder_437914C6(list_type(LabelPrintItem_$reflection()), undefined, undefined, undefined)(items))], successMsg, errorMsg);
}

export function printLabels(request, successMsg, errorMsg) {
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), LabelPrintResponse_$reflection()));
        }, refreshOn)))(true);
    })), ["/api/labels/print", toString(0, Auto_generateBoxedEncoder_437914C6(LabelPrintRequest_$reflection(), undefined, undefined, undefined)(request))], successMsg, errorMsg);
}

export function previewLabel(item, successMsg, errorMsg) {
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), LabelPreviewData_$reflection()));
        }, refreshOn)))(true);
    })), ["/api/labels/preview", toString(0, Auto_generateBoxedEncoder_437914C6(LabelPrintItem_$reflection(), undefined, undefined, undefined)(item))], successMsg, errorMsg);
}

export function getReservedCodes(successMsg, errorMsg) {
    return Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder_1(0, addPrefix_1(url), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(ReservedQrCodeDto_$reflection())));
    })))), "/api/labels/reserved-codes", successMsg, errorMsg);
}

export function deleteReservedCode(code, successMsg, errorMsg) {
    return Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["DELETE"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => {
                Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), unit_type);
            });
        }, refreshOn)))(true);
    })), concat("/api/labels/reserved-codes/", ...encodeURIComponent(code)), successMsg, errorMsg);
}

